import type React from 'react';
import { useFieldContext } from '../FormContext';
import styles from './NumberField.module.css';

export const NumberField: React.FC = () => {
  const { field, value, onChange } = useFieldContext();

  if (field.type !== 'number') {
    throw new Error('NumberField can only be used with number field type');
  }

  return (
    <div>
      <label className="label" htmlFor={field.name}>
        {field.label}
      </label>
      {field.description && (
        <p className="description">{field.description}</p>
      )}
      <input
        id={field.name}
        type="number"
        value={value ?? field.defaultValue ?? 0}
        min={field.min}
        max={field.max}
        step={field.step}
        onChange={(e) => onChange(parseFloat(e.target.value))}
        className={styles.numberInput}
      />
    </div>
  );
};
